import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import MobileStores from '~/src/features/agent/components/MobileStores';

import * as ST from './styled';

const imgStaticPath = '/static/images/service/agent';

const BottomBlock = ():JSX.Element => {
    const isMobile = useMatchMedia(`(max-width: ${wideBreakpoints.mobile})`);

    const currentImg = isMobile ? 'iPhone_Bottom_mobile' : 'iPhone_Bottom';

    return (
        <ST.BottomWrapper>
            <ST.BottomContent>
                <ST.BottomTitle>Скачивайте приложение, чтобы управлять услугами онлайн</ST.BottomTitle>
                <MobileStores position={'down'}/>
            </ST.BottomContent>
            <ST.BottomImage>
                <ST.BottomImageInner>
                    <WebpImage urlWebp={`${imgStaticPath}/${currentImg}.webp`}>
                        <ST.Image
                            src={`${imgStaticPath}/${currentImg}.png`}
                            alt='Изображение мобильного телефона с приложением Дом.ру'
                            data-test='block-pic'
                        />
                    </WebpImage>
                    <ST.SMobileStoreQrLabel/>
                </ST.BottomImageInner>
            </ST.BottomImage>
        </ST.BottomWrapper>
    );
};

export default BottomBlock;
